module.exports = __webpack_public_path__ + "img/jsonpath-help2.6673fb3c.png";